import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { toast } from "sonner";
import { API, getContentSource } from "@/lib/constants";
import { hubspotContext } from "@/lib/hubspot";

const LeadPopup = ({ isOpen, onClose, type = "ebook" }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', company: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await axios.post(`${API}/leads`, {
        ...formData,
        source: type === "ebook" ? "ebook_popup" : "community_popup",
        lead_magnet: type === "ebook" ? "2026 AEO & GEO Tactics Ebook" : "AI Community Signup",
        ...hubspotContext()
      });
      
      toast.success("Success! Check your email for the download link.");
      onClose();
      setFormData({ firstName: '', lastName: '', email: '', company: '' });
      navigate("/thank-you/lead?from=guide");
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-[#0A0A0A] border border-white/10 max-w-md" data-testid="lead-popup">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-white">
            {type === "ebook" 
              ? "Download the 2026 AEO & GEO Tactics" 
              : "Join the Digital Media Ninja AI Community"}
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            {type === "ebook" 
              ? "Get our comprehensive guide to dominating AI search in 2026. Free instant download."
              : "Connect with other marketing professionals and get exclusive AI insights."}
          </DialogDescription>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} id="guide-download-form" name="guide-download-form" className="space-y-4 mt-4">
          <input type="hidden" name="content_source" value={getContentSource()} />
          <div className="grid grid-cols-2 gap-4">
            <Input
              name="first_name"
              placeholder="First Name"
              value={formData.firstName}
              onChange={(e) => setFormData({...formData, firstName: e.target.value})}
              className="form-input"
              required
              data-testid="popup-first-name"
            />
            <Input
              name="last_name"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={(e) => setFormData({...formData, lastName: e.target.value})}
              className="form-input"
              required
              data-testid="popup-last-name"
            />
          </div>
          <Input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            className="form-input"
            required
            data-testid="popup-email"
          />
          <Input
            name="company"
            placeholder="Company (Optional)"
            value={formData.company}
            onChange={(e) => setFormData({...formData, company: e.target.value})}
            className="form-input"
            data-testid="popup-company"
          />
          <Button 
            type="submit" 
            className="btn-ninja w-full"
            disabled={isSubmitting}
            data-testid="popup-submit"
          >
            {isSubmitting ? "Processing..." : type === "ebook" ? "Download Now" : "Join Community"}
          </Button>
          <p className="text-xs text-gray-500 text-center">
            By submitting, you agree to receive marketing communications. Unsubscribe anytime.
          </p>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default LeadPopup;
